import callStaff from "containers/call-staff";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  eng: {
    translation: {
      orderNow: "Order now",
      viewOrderedDishes: "View ordered dishes",
      table: "Table",
      waitingStaffConfirm: "Waiting for staff confirmation",
      pointAccrual: "Earn points",
      callStaff: "Call ST",
      buffet: "Buffet",
      alc: "Alacarte",
      foodBasket: "Food basket",
      dish: "dish",
      dish1: "Dish",
      orderSuccessfully: "Order successfully!",
      viewStatusYourOrder: "View the status of your order",
      notSelectedDishes: "You haven't added any items to your food basket yet.",
      youJustOrdered: "You just ordered",
      chooseDishNow: "Choose a dish now",
      orderMoreDish: "Do you want to order more dishes?",
      deselectDish: "Do you want to deselect dishes ",
      dishes: "Dishes",
      orderMore:
        "currently waiting for service, are you sure you want to order more?",
      orderConfirmation: "Order Confirmation",
      addToPaymentBill: "Will be added to the payment bill",
      temporarilyCalculateMoney: "Temporarily calculate money",
      ok: "Ok",
      cancel: "Cancel",
      errorVatUnitCode: "You have entered more than 7 characters",
      order: "Order",
      notifyRestaurant: "thông báo món",
      notOutYet: "chưa ra",
      promptingOutDishes: "giục ra món",
      noticeToRes: "Notice has been sent to the restaurant!",
      paymentRequest: "yêu cầu thanh toán",
      paymentRequest1: "yêu cầu hỗ trợ thanh toán",
      served: "Served",
      orderedDishPrepared: "Prepared",
      inService: "In service",
      notifyRestaurantDish: "Notify the restaurant that prompted this dish?",
      notifyRestaurantDishOutYet:
        "Notify the restaurant that this dish has not come out yet?",
      orderedDishTable: "Ordered dish - Table",
      orderedDish: "Ordered Dish",
      orderMoreDishes: "Order more",
      dishName: "Name of dish",
      dishUnit: "dishes",
      quantityShort: "Qty",
      cartLabel: "Cart",
      checkoutOrderTitle: "Order payment",
      paymentRequestReceivedMessage: "The restaurant has received your payment request.",
      pleaseWait: "Please wait a moment.",
      scanQrToContinue: "Please scan the QR code to continue!",
      customerCareHotline: "Customer Care Hotline",
      voucherDiscountLimitNote:
        "Total discount amount does not exceed 255,000 VND",
      callPaymentSuccess: "Payment request sent successfully",
      noRatingList: "No rating list available",
      noTippingList: "No tipping list available",
      noMenuList: "No menu list available",
      servingPeriodMenuUpdatedTitle:
        "The menu has been updated for the current serving period.",
      servingPeriodMenuUpdatedDescription:
        "Please refresh to see the latest menu.",
      invalidAmountFormat: "Invalid amount format",
      tipAmountDigitsOnly: "Tip amount must contain digits only",
      paymentDetailsTitle: "Payment details",
      subtotalBeforeVat: "Subtotal before VAT",
      promotionApplied: "Promotion applied",
      discountBeforeVat: "Discount before VAT",
      totalAfterVat: "Total after VAT",
      voucherAfterVat: "Voucher after VAT",
      status: "Status",
      invoke: "Invoke dish",
      menuRestaurantTitle: "Restaurant menu",
      total: "Total",
      callPay: "Call to pay",
      callingStaff: "Calling staff",
      callStaffTitle: "Call Staff",
      endCall: "End call",
      option: "Option",
      dosing: "Select Dosing",
      addTopping: "Add topping",
      or: "Or",
      yourRequest: "Your request",
      noteFordish: "Enter your note for the dish...",
      update: "Update",
      addDish: "Add Dish",
      chooseupto: "You can only choose up to",
      vnd: "VND / PERSON",
      choose: "Choose now",
      group: "Group",
      chooseAtLeast: "must choose at least",
      product: "product",
      cantChooseMore: "can't choose more",
      fixedDishGroup: "Fixed dish group",
      selectGroup: "Select group",
      youAreChosen: "You are chosen",
      onTotal: "dish in total",
      requireSupported: "yêu cầu hỗ trợ",
      orderWithin: "Please order within",
      orderWithin2:
        "plate for fastest service and order next time\n! Unlimited number of calls.",
      orderWithin3: "There are many delicious desserts waiting for you!",
      hero: "Hero doesn't waste.",
      hellGGG: "Hello Golden Gate",
      havingProgram: "We are having program",
      learnProgram: "would you like to learn this program?",
      note: "When your status bar changes color, it's the possibility of excess food on your table you are gradually increasing, in degrees from yellow (medium) to red (high).View program information.",
      hero2: "Hero DOESN't waste.",
      gpos: "The current G-POS version is lower than the required version, please contact IT for support",
      gposInvalidVersion:
        "The current G-POS version is lower than the required version, please contact IT for support",
      error: "Error please try again later!",
      internalServerError:
        "The system is temporarily interrupted. Please try again later.",
      forDev: "For developers",
      confirm: "Confirm",
      price: "Price",
      noteForFwMw: "đã có trong set",
      noteForFwMw2: ", quý khách vui lòng gọi thêm trong lượt tiếp theo.",
      noteForFwMw3: "Bạn có biết",
      noteForFwMw4: "đã có trong",
      noteForFwMw5: "đặc sắc của",
      noteForFwMw6: "chưa?",
      noteForFwMw7: "Mời bạn khám phá thử combo đặc biệt này trước nhé.",
      textTitleBuffetExtra: "Notification",
      textContentBuffetExtra: "Order now",
      ticket: " ticket",
      textContentBuffetExtra1:
        " to order as many dishes as you like in the Extra menu!",
      textContentButtonLeft: "Continue choosing items",
      textContentButtonAddCart: "Go to cart",
      textContentBuffetExtra2: "Buy more",
      textContentBuffetExtra3:
        " to order as many dishes as you like on the Extra menu!",
      textContentButtonLeft1: "Call Staff",
      tippingNow: "Hot tip",
      tippingInfo: "Keep the staff motivated",
      tippingContent: "Any of your options are",
      tippingContent1: "motivates us.",
      skip: "Skip",
      tippingPlaceHolder: "Or enter tip amount...",
      ratingTitle:
        "Please give us your feedback so we can help you have an experience",
      ratingTitle1: "more complete!",
      ratingContent: "What do you want to improve?",
      submitConfirm: "Submit confirmation",
      notifyContentTipping: "Thank you very much.",
      notifyContentError: "Please select a tip level.",
      notifyContentSubmitRatingSuccess: "Rating submitted successfully",
      notifyContentRating: "Share your experience here",
      notifyContentTimeoutCallStaff: "Your call is temporarily disconnected.",
      notifyContentTimeoutCallStaff1:
        "Please call the nearest staff member for service.",
      close: "Close",
      notifyContentErrorComment: "You have not selected a review",
      textTitleChooseLanguage: "Choose language to continue",
      textVietnamese: "Tiếng việt",
      textEnglish: "English",
      textContinue: "Continue",
      ratingContent2: "Send your compliments",
      orderMore1: "Call more",
      paymentNow: "payment Now",
      foodBasket1: "Food Basket",
      needSevice: "Ask for food",
      skip1: "Skip",
      searchPlaceHolder: "Search...",
      textSorry: "SORRY !",
      textSorryContent:
        "There are no matching search results. Please try again with another keyword",
      select: "Select",
      in: "in",
      noteTitle: "Note",
      listDishTitle: "List of dishes in the set",
      titleQrCode:
        "Have you finished your lunch and confirmed you want to pay?",
      back: "Back",
      check: "Check",
      titleQrCodePaymentPopup: "Đã nhận được yêu cầu của bạn",
      contentQrCodePaymentPopup:
        "Please wait a moment, a staff member will assist you with the payment.",
      tippingContent2: "Advice for your service staff, as a thank you!",
      tippingContent3: "You tipped",
      notifyContentMaxTextNote: "Do not enter more than 100 characters.",
      notifyContent: "Please select ",
      notifyContinue: " to continue",
      cancelTippingDraftSuccess: "Canceled tipping successfully",
      paymentInfo: "Order information",
      dishOrderedTitle: "Ordered dish",
      productDetail: "Product Details",
      loadMore: "See more",
      all: "All",
      paymentTitle: "Payment method",
      vatTitle: "Export VAT invoice",
      vatSheetTitle: "Export VAT invoice",
      vatSheetDesc1:
        "Please select “Export VAT invoice” before paying if you need an invoice with your own details. Otherwise, the system issues a retail-customer invoice by default and it cannot be changed.",
      vatSheetDesc2:
        "Note: Tips are not subject to VAT and are not included in the VAT invoice.",
      understood: "Got it",
      detail: "Detail",
      totalPaymentTitle: "Total amount to be paid",
      shorten: "Shorten",
      titleVat: "Add invoice information",
      vat1: "Have tax code",
      vat2: "No tax code",
      placeholderTaxCode: "Enter tax code",
      companyNameHolder: "Name of unit/individual issuing invoice *",
      addHolder: "Address*",
      addHolder1: "Address",
      placeholderPhoneNumber: "Phone number*",
      placeholderEmail: "Email*",
      placeholderId: "No CCCD",
      placeholderCustomerName: "Customer Name",
      errorVat:
        "The tax code is not in the correct format. The tax code is not in the correct format. The correct format is 10 numeric characters (0123456789) or 14 characters including 13 numeric characters and the character " -
        " (0123456789-012 ).",
      errorNoInputVat: "You have not entered your tax code",
      errorVatPhone:
        "Phone number format includes only numeric characters, no spaces and starts from 0.",
      errorVatEmail: "Email format is acb@domain.",
      inputInfo: "Enter information",
      contentErrorNoInfoVat:
        "Please check your tax code [MST] or manually enter invoicing information.",
      titleErrorNoInfoVat: "Tax code cannot be looked up",
      errorNoInputEmailVat: "This is a required field.",
      warningInfoCompanyName:
        "If you want to get a personal contract, please enter your full name in this box.",
      titleTax: "Tax code",
      titleCompanyName: "Name of unit/individual:",
      titleAdd: "Address:",
      titlePhone: "Phone number:",
      titleEmail: "Email:",
      edit: "Edit",
      tipTitle: "Tip for the staff who served you",
      tipTitle1: "As a thank you",
      titleCustomerName: "Shopper name:",
      titleCCCD: "CCCD Number",
      change: "Change",
      goldenSpoonsTitle: "Log in so you don't miss out on reward points",
      loginTitleNow: "Over 80% of customers at {{brand}} earned points today.",
      placeholderPhone: "Enter your phone number",
      textButtonLogin: "Log in to earn points with Golden Gate",
      placeHolderPass: "Enter your password",
      or: "Or",
      loginWithGoldenGateApp: "Log in with Golden Gate App",
      loginButtonShort: "Log in",
      logout: "Log out",
      cannotOpenGoldenGateApp:
        "Unable to open the Golden Gate app. Please try again or sign in with your phone number.",
      appLoginSyncError:
        "Unable to synchronize your Golden Gate login. Please try again.",
      appLoginSessionExpiredTitle: "Authentication session has expired",
      appLoginSessionExpiredContent: "Please try again.",
      appLoginNoInternetTitle: "No Internet connection",
      appLoginNoInternetContent:
        "Please check your connection and try again.",
      textContinuePayment: "Continue payment",
      titleErrorSignUp: "Signup error detected",
      contentErrorSignUp2:
        "The phone number is attached to multiple accounts, please contact hotline “19006622” for support.",
      contentErrorSignUp:
        "The phone number is attached to multiple accounts, please contact",
      callNow: "Call",
      phoneValidError: "Phone number is not in the correct format",
      contentErrorSignUp1: "for support",
      hello: "Hello,",
      loginContentWithPhone: "You are logging in with your phone number",
      forgotPass: "Forgot Password?",
      contentForgotPass:
        "Please open the Golden Gate application to recover your new login password",
      textErrorPhone: "Phone number must have 10 digits",
      verifyOTPTitle: "Verify OTP",
      inputOTPTitle: "Enter the 4-digit code sent to",
      titleResendOTP: "Resend OTP later",
      titleResendOTP1: "Resend OTP",
      titleWrongOtp: "Incorrect OTP code entered 5 times",
      contentWrongOtp: "Please try again later",
      contentWrongOtp1: "day minutes",
      errorOtp: "The OTP code is wrong or expired. You still have it",
      errorOtp1: "import attempt.",
      errorPassword: "The password has been entered incorrectly 5 times",
      errorContentPassword:
        "Your account has been locked. Please try again in 30 minutes.",
      errorCorrectPassword: "Incorrect password! You still have",
      errorCorrectPassword1: "import attempt.",
      titlePasswordTab: "Login password",
      contentPasswordTab: "Passwords make your account more secure and safe.",
      titleCreatePassword: "Create password",
      titleConfirmPassword: "Confirm password",
      noteForPassword:
        "By continuing, you acknowledge that you have read and agree to the Terms of Use, Privacy Policy and Membership Policy.",
      noteForPassword2: "Terms of Use.",
      errorPasswordCreate: "Password needs at least 6 numbers",
      errorPasswordConfirm: "Passwords do not match",
      textConfirmCloseModalSignin:
        "Are you sure you want to exit GS Account Registration/Login",
      textConfirmSignUpSuccess: "Account registration successful.",
      titleVoucher: "Offer",
      titleSearch: "Search",
      contentNoVoucher: "There are no special offers for you yet",
      expiryDate: "expiry Date",
      placeholderInputVoucher: "Enter discount code...",
      textCheckedVoucer: "Selected",
      textvoucher: "offer",
      applyNow: "Apply now",
      applyTitleNow: "Ưu đãi giảm giá:",
      cancelApply: "Cancel Apply",
      addApplyVoucher: "Apply location:",
      validateApply: "Conditions apply",
      listDishApplyVoucher: "List of dishes to which the promotion applies",
      noSubmit: "Not yet called",
      submitted: "Called",
      voucherError: "Invalid voucher",
      contentErrorVoucher:
        "Sorry, this offer is currently not available for orders. Please see other available vouchers.",
      titleScanQrcode: "Scan QR",
      titlePartner: "Payment methods",
      paymentInfoTitle: "Payment information",
      totalPayment: "Total payment",
      texttotalPayment: "Total payment",
      textTotalTip: "Tip",
      reloadQRCode: "Tải lại QRCode",
      openVinIdAppNow: "Open OneU app now",
      errorConfirmPayment: "Vui lòng đợi thêm một chút nhé",
      errorConfirmPayment1:
        "A payment session is in progress. Do you want to open a new payment session?",
      contentErrorConfirmPayment: "Staff is assisting you with payment",
      contentAccountAddPoint:
        "The order has accumulated points for the account",
      addPoint: "so vouchers cannot be used in Golden Gate wallet.",
      checkedTgsAccount:
        "The order has been accumulated points for the customer code",
      checkedTgsAccount1: ".Do you confirm to continue payment?",
      errorConfirmPayment2: "A payment session is in progress.",
      paymentInfoTitle1: "Payment slip",
      momoTitlePayment: "Payment via Momo e-wallet",
      momoContentPayment:
        "Open the app on your device to complete payment at the restaurant",
      openMomoAppNow: "Open Momo app now",
      paymentByQrCode: "Pay by QR code",
      paymentByQrCode1: "Pay QR code",
      saveQrCode: "Save QR code ",
      titleCheckPaymentStatus: "Check payment status",
      errorNoSelectPaymentPartner: "You have not selected a payment method.",
      serveyService: "Service Review",
      paymentSuccessTitle: "Payment successful",
      paymentSuccessContent:
        "Share with us your experience by rating this meal!",
      paymentSuccessTitleByCash: "Customer please pay with the service staff.",
      titleByCash: "Thank you, see you soon.",
      titleContent: "Are you sure you want to return to the payment screen?",
      titleAppInApp: "Payment via App MoMo",
      titleAppInApp1: "Payment via App",
      verifyPayment: "Verifying payment",
      payment: "Payment",
      verifyPaymentContent:
        "The system is checking and authenticating your payment. Please wait!",
      verifyPaymentContent1:
        "Please do not close the application while you are making a payment, the browser will automatically proceed after completion.",
      voucherNoValidTitle: "Voucher not valid",
      voucherNoValidContent:
        "Sorry, this offer is currently not available for orders. Please see other available vouchers.",
      titleApplyVoucherError: "Voucher application failed",
      contentApplyVoucherError:
        "Please uncheck the error vouchers to continue payment or view more available vouchers.",
      removeSelectVoucher: "Deselect Voucher",
      contentApplyVoucher:
        "Are you sure you want to checkout without applying that voucher?",
      voucherErrorCheck:
        "Are you sure you want to checkout without applying that voucher",
      unSelectVoucher: "Bỏ chọn Voucher",
      errorTitleWhenCheckTGS: "An error occurred while accumulating points",
      paymentByGbizTitle: "Pay with G-Business account",
      accountLimit: "Account limit:",
      amountToPay: "Amount To Pay:",
      totalAmount: "Total amount payable",
      titleErrorWhenPayment: "Transaction not yet paid",
      errorTitle: "An error occurred",
      noTakeVat: "You have confirmed not to take the invoice.",
      noTakeTaxTitle: "Please contact",
      rm: "RESTAURANT MANAGER",
      support: " for support.",
      contentNotifyLockOrder:
        "Bạn đã xác nhận kiểm đồ, liên hệ nhân viên để gọi thêm món.",
      errorNoApplyDish:
        "You have not ordered a dish from the list of offered dishes.",
      contentErrorTimeOut:
        "Sorry, please try again in a few minutes. Or call the nearest staff directly.",
      termAndCondition: "Terms of Use",
      prepayPaymentDone: "You have completed payment",
      scanByCam: "Scan using camera",
      chooseImage: "Choose from image library",
      titleErrorSignUp1: "Account is locked",
      contentErrorSignUp3:
        "Your account is locked, please contact hotline “19006622” for support.",
      titleLoadImageQrCode: "QRCode not found in image",
      contentLoadImageQrCode:
        "Sorry, the system could not find the Qrcode of the voucher photo you uploaded. Please select another photo and try again.",
      titleModalRemoveVoucher: "Order has accumulated points",
      textRemoveVoucherButton: "Remove voucher from wallet",
      contentRemoveVoucher1:
        "Please deselect the vouchers in your GS wallet in the voucher details section, or click the “Put voucher in wallet” button to continue payment.",
      contentRemoveVoucher2: "“Put your voucher in your wallet”",
      contentTypeOne:
        "Please log in to your Golden Gate account and select the voucher in your wallet to use.",
      titleTypeOne: "Offer not valid",
      titleQrCodePaymentPopup1: "Your request has been received.",
      contentTypeGiftOne:
        "Voucher is not supported for use on QrCode Order. Please scan QrCode to check items with GS app to use this voucher.",
      choosePaymentMethodVinId: "Choose payment method",
      usePointVinId: "Use U-Point",
      walletVinId: "OneU Wallet",
      titleVinId: "Enter the amount you want to pay with OneU points",
      placeholderVinId: "Enter amount here",
      errorVinId: "Please pay the entire bill with tip or enter up to",
      errorVinId1:
        "The amount you want to pay with U-Points cannot be greater than the total amount to be paid for the order.",
      payByVinIdTitle: "Pay with OneU points",
      chooseCategory: "Choose menu",
      ordertopay: "Order to pay",
      chooseMenu: "Choose menu",
      justOne: "Just words",
      openTable: "Choose Menu",
      titleAppInAppVinId: "Payment via App OneU",
      chooseAgain: "Choose Again",
      chooseCategoryConfirm: "Are you sure you want to choose ",
      justOne1: "with prices starting from",
      justOne2: "with price",
      justOne3: "/Dish",
      chooseMenuOverTime: "Choose Menu session has expired",
      chooseMenuOverTimeContent:
        "Please contact the nearest staff to select the menu or rescan the QRCode Order.",
      groupCombo: "Fixed group of dishes",
      titleHideCategory: "Menu is configured to hide orders on Qrcode",
      contentHideCategory:
        "We are sorry for your incomplete experience at the restaurant. Please contact the nearest staff to assist you.",
      person: "/Person",
      oneMountTitlePayment: "Payment via OneU e-wallet",
      titleBackPayment: "Return to payment screen",
      titleErrorWhenPayment1: "Transaction is being updated for payment",
      titleVatNotify: "Are you sure you don't want a VAT invoice?",
      textInfo: "Please share your feedback to get immediate support!",
      sendNow: "Send now",
      tipped: "Tipped",
      serviceFeedback: "Service Feedback",
      serviceFeedbackContent: "Your opinion matters.",
      serviceFeedbackContent1: "Let us listen and act for you.",
      callManager: "Call manager now",
      noteFeedback: "Your feedback",
      notifyContentFeedback: "Share your feedback here",
      policyValidError: "You have not accepted the terms of use.",
      totalPaymentDiscount: "Product price to which discount is applied",
      phomeNumberFeedback: "Your phone number",
      hintTextTip: "Enter tip amount",
      feedbackSuccess: "Feedback sent successfully",
      choose1: "Choose",
      of: "of",
      notifyContentChooseComponent:
        "You have not selected an item in the combo",
      chooseSize: "Choose size",
      textTitleNoInternet: "No internet connection",
      apiNoResponse: "API is not responding",
      textReload: "Reload",
      textContentNoInternet:
        "Please check your network connection and try again.",
      errorPaymentOnemount:
        "The system will automatically switch the screen when the payment is successful, or you can click the [Check payment status] button to check the transaction status.",
      noGPos: "Can't get G-POS version. Please reload the page and try again!",
      textNoChooseHotpotWater: "You have not selected hotpot water",
      hotpot2Compartment: "2-compartment hotpot",
      hotpot4Compartment: "4-compartment hotpot",
      toastMaxHotpot: "You can select up to {{max}} hotpot compartments",
      chooseHotpotFree:
        "You can choose {{free}} hot pot compartments for free, the next compartments will be charged.",
      notifyDishNoExtraHotpot: "We are very sorry about the dish",
      notifyDishNoExtraHotpot2:
        "not configured for the hot pot compartment. Please call the nearest staff for assistance with ordering.",
      chooseToAddHotpotFree:
        "You can also choose to add {{free}} free hot pot compartments",
      confirmSubmitHotpotTitle: "Are you sure you want to select",
      hotpotBroth: "Hotpot broth",
      selectMore: "Select more",
      useBoilingWater: "Use boiling water",
      selectAnotherType: "Select another type",
      notConfigHotpotCharging: "Dishes not configured for hot pot charging",
      ChooseMyHotpot: "Choose your hotpot broth",
      notifyHopot2:
        "You have selected 4-compartment hot pot, you cannot select 2-compartment hot pot.",
      apply: "Apply: ",
      notifyHopot4:
        "You have selected 2-compartment hot pot, you cannot select 4-compartment hot pot.",
      notifyHotpot3: "You cannot re-select the 4-compartment hot pot.",
      notifyHotpot7: "You cannot reselect the 2-compartment hotpot.",
      notifyHotpot5:
        "Are you sure you want to switch to the 4-compartment hotpot?",
      notifyHotpot6:
        "Are you sure you want to switch to the 2-compartment hotpot?",
      messageFwIsushi:
        "You have selected enough dishes for this turn! Enjoy before continuing.",
      times: "times",
      hour: "Hour",
      hottip: "Hot tip",
      contentHottip:
        "Please give a shout out to the staff who helped make your day a memorable one. Enjoy your meal!",
      unitCode: "Budget relationship unit",
      contentLockTGS:
        "Sorry, you can't earn points because you've reached the maximum number of points you can earn in this time frame",
      orderProcessing: "Processing order",
      contentErrorSubmitOrder:
        "Your previous order is being processed. Please wait a moment before ordering your next order.",
      tippingContent12: "Recognition for employees",
      pointSurvey: "Score: ",
      surveyTitle: "Please rate your experience for recognition",
      retry: "Retry",
      retryOrAnotherPayment:
        "Please try again or choose another payment method",
      contentTipping:
        "If you’d like to show your appreciation to our service team today, all tips will be passed directly to the staff",
      surveyTitle3: "Please rate your experience to give the restaurant credit",
      tippingForStaff: "Tip for Staff",
      tippingMost: "TIP most",
      callStaff1: "Call Staff",
      contentTilteCallStaff:
        "Please contact a staff member for assistance with ordering.",
      orderDish: "Order",
      timeSteaming: "Steaming time:",
      minute: "'",
      relateTitleDish: "Suggested side dishes",
      feedback: "Feedback",
      contentTilteCallStaff1:
        "Please contact a restaurant staff member for immediate assistance!",
      noteFromTotalPayment:
        "The total amount excludes VAT and other service fees",
      noteFromTotalPayment1:
        "The estimated price does not include VAT and other service fees",
      textButtonVat: "Enter VAT invoice information",
      textNoteVat:
        "Or please click the 'Enter VAT invoice information' button below.",
      textTks: "has been paid for, thank you.",
      textTks1: "Remember to come back and show your support!",
      textTks2: "us next time",
      textTitelPersonal: "Consent to the use of personal data.",
      textContentPersonal:
        "When using the QR code ordering application at the restaurant, you agree to allow us to collect and process certain data, including: identification information (if provided), order history, service usage time, and interactions within the application..",
      textContentPersonal1:
        "This data will be transferred to our Customer Data Platform (CDP) system for the following purposes:",
      textContentPersonal2:
        "To personalize offers and promotions based on your preferences.",
      textContentPersonal3:
        "To send invitations for surveys regarding your restaurant experience or the dishes you have used.",
      textContentPersonal11:
        "To analyze and improve the quality of our products and services.",
      textContentPersonal4: "We are committed to:",
      textContentPersonal5:
        "Using your data solely for the purposes stated above.",
      textContentPersonal6:
        "Not sharing your data with unauthorized third parties.",
      textConfirmPersonal: "Accept",
      textCancelPersonal: "Reject",
      textLinkPolicyPersonal:
        "View more about the information security policy.",
      priceTitel: "Price",
      intoMoney: "Total amount",
      itemDish: "Urging the dish to success",
      confirmMenuChange: "Are you sure you want to change from {oldMenu} to {newMenu}?",
      confirmDeleteAllCart: "Are you sure you want to remove all items from your cart?",
      confirmOrder: "Confirm Order",
      complimentary: "COMPLIMENTARY",
      addItemsNow: "Add items now",
      notOrderedItemsYet: "You haven't ordered any items yet.",
      items: "items",
      item: "item",
      deleteAllItems: "Delete all items",
      backOrder: "Back to Ordering",
      continuePayment: "Continue payment",
      add: "Add",
      staffAssistCardPayment: "Our staff will assist you with card payment",
      staffAssistCardPaymentNoti:
        "Please hand your card to our staff and keep this screen open. The system will update automatically after successful payment",
      rateStarText: "Give {{name}} a rating!",
      rateStarTextBefore: "Give",
      rateStarTextAfter: "a rating!",
      tipSentTo: "Your tip will be sent to",
      submitWithTip: "Submit Rating & Tip",
      topTipper: "Top Tipper",
      orEnterTip: "Or enter your tip amount...",
      tipSplitMessage:
        "Send a tip to say thanks – 70% goes to <b>{{name}}</b>, 30% is shared with the service team.\nTips are not subject to VAT and are not included in the VAT invoice.",
      noTipOption: "No Tip",
      youTipped: "You tipped",
      rateTipConfirmButton: "Confirm",
    },
  },
  vie: {
    translation: {
      orderNow: "Gọi món ngay",
      viewOrderedDishes: "Xem món đã gọi",
      table: "Bàn",
      waitingStaffConfirm: "Chờ NV xác nhận",
      pointAccrual: "Tích điểm",
      callStaff: "Gọi NV",
      callStaff1: "Gọi Nhân Viên",
      buffet: "Món buffet",
      alc: "Món tính tiền",
      foodBasket: "Tạm tính",
      foodBasket1: "Giỏ đồ ăn",
      dish: "món",
      dish1: "Món",
      apply: "Áp dụng: ",
      orderSuccessfully: "Gọi món thành công!",
      viewStatusYourOrder: "Xem trạng thái món đã gọi",
      notSelectedDishes: "Bạn chưa thêm món nào vào giỏ đồ ăn.",
      youJustOrdered: "Bạn vừa gọi ",
      chooseDishNow: "Chọn món ngay",
      orderMoreDish: "Bạn có chắc chắn muốn gọi thêm?",
      deselectDish: "Bạn có muốn bỏ chọn món ăn ",
      dishes: "Bạn vừa gọi",
      orderMore: ", bạn có chắc chắn muốn gọi thêm?",
      orderConfirmation: "Gọi món của bạn",
      addToPaymentBill: "Sẽ được cộng vào bill thanh toán",
      temporarilyCalculateMoney: "Tạm tính",
      ok: "Đồng ý",
      cancel: "Huỷ",
      order: "Gọi món ngay",
      notifyRestaurant: "thông báo món",
      notOutYet: "chưa ra",
      promptingOutDishes: "giục ra món",
      noticeToRes: "Thông báo đã được gửi tới nhà hàng!",
      paymentRequest: "yêu cầu thanh toán",
      paymentRequest1: "yêu cầu hỗ trợ thanh toán",
      served: "Đã phục vụ",
      orderedDishPrepared: "Đã chế biến",
      inService: "Đang chế biến",
      notifyRestaurantDish: "Món chưa ra? Vui lòng phản hồi ngay tại đây nhé!",
      notifyRestaurantDishOutYet:
        "Món chưa ra? Vui lòng phản hồi ngay tại đây nhé!",
      orderedDishTable: "Món đã gọi - Bàn",
      orderedDish: "Món đã gọi",
      orderMoreDishes: "Gọi thêm",
      dishName: "Tên món",
      dishUnit: "món",
      quantityShort: "SL",
      cartLabel: "Giỏ hàng",
      checkoutOrderTitle: "Thanh toán đơn hàng",
      paymentRequestReceivedMessage: "Nhà hàng đã nhận yêu cầu thanh toán của bạn.",
      pleaseWait:"Vui lòng chờ trong giây lát.",
      scanQrToContinue: "Vui lòng quét Qr-Code để tiếp tục!",
      customerCareHotline: "Hotline Chăm sóc Khách hàng",
      voucherDiscountLimitNote:
        "Tổng số tiền giảm giá không vượt quá 255.000 vnđ",
      callPaymentSuccess: "Gọi thanh toán thành công",
      noRatingList: "Không có danh sách rating",
      noTippingList: "Không có danh sách tipping",
      noMenuList: "Không có danh sách món",
      servingPeriodMenuUpdatedTitle:
        "Thực đơn đã được cập nhật theo khung giờ phục vụ.",
      servingPeriodMenuUpdatedDescription:
        "Bạn vui lòng tải lại để xem nhé!",
      invalidAmountFormat: "Số tiền không đúng định dạng",
      tipAmountDigitsOnly: "Số tiền tip chỉ gồm ký tự số",
      paymentDetailsTitle: "Chi tiết thông tin thanh toán",
      subtotalBeforeVat: "Tổng tiền hàng trước VAT",
      promotionApplied: "Được áp dụng khuyến mãi",
      discountBeforeVat: "Tổng tiền giảm giá trước VAT",
      totalAfterVat: "Tổng tiền sau VAT",
      voucherAfterVat: "Tổng voucher sau VAT",
      status: "Trạng thái",
      skip: "Để sau",
      skip1: "Bỏ qua",
      invoke: "Giục ra món",
      menuRestaurantTitle: "Menu nhà hàng",
      total: "Tổng",
      callPay: "Gọi thanh toán",
      callingStaff: "Đang gọi nhân viên",
      endCall: "Kết thúc gọi",
      callStaffTitle: "Gọi nhân viên",
      option: "Tùy chọn",
      dosing: "Chọn định lượng",
      addTopping: "Thêm topping",
      or: "Hoặc",
      yourRequest: "Yêu cầu của bạn",
      noteFordish: "Nhập lưu ý của bạn cho món ăn...",
      update: "Cập nhật",
      addDish: "Thêm vào giỏ",
      chooseupto: "Bạn chỉ có thể chọn tối đa",
      vnd: "VND / NGƯỜI",
      choose: "Chọn ngay",
      group: "Nhóm",
      chooseAtLeast: "phải chọn ít nhất",
      product: "sản phẩm",
      cantChooseMore: "không được chọn nhiều hơn",
      fixedDishGroup: "Nhóm món cố định",
      selectGroup: "Chọn nhóm",
      select: "Chọn",
      youAreChosen: "Bạn được chọn",
      onTotal: "món trên tổng số",
      requireSupported: "yêu cầu hỗ trợ",
      orderWithin:
        "Để đảm bảo phục vụ nhanh nhất, bạn vui lòng đặt trước trong vòng",
      orderWithin2:
        " đĩa, sau đó bạn tiếp tục gọi thêm mà không giới hạn số lần.",
      orderWithin3: "Còn nhiều món tráng miệng hấp dẫn đang chờ bạn nhé!",
      hero: "Người hùng không lãng phí.",
      hellGGG: "Golden Gate xin chào.",
      havingProgram: "Chúng tôi đang có chương trình",
      learnProgram: "bạn có muốn tìm hiểu chương trình này không?",
      note: " Khi thanh trạng thái của bạn đổi màu, là khả năng bị thừa thức ăn trên bàn của bạn đang dần tăng lên, theo mức độ từ vàng (trung bình) đến đỏ (cao). Xem thông tin chương trình.",
      hero2: "Người hùng KHÔNG lãng phí.",
      gpos: "Không lấy được thông tin version GPOS. Xin vui lòng thử lại sau.",
      gposInvalidVersion:
        "G-POS version hiện tại đang thấp hơn phiên bản yêu cầu, vui lòng liên hệ IT để được hỗ trợ",
      error: "Lỗi vui lòng thử lại sau!",
      internalServerError:
        "Hệ thống tạm thời gián đoạn. Xin vui lòng thử lại sau.",
      forDev: "Dành cho nhà phát triển",
      confirm: "Xác nhận",
      price: "Giá",
      noteForFwMw: "đã có trong set",
      noteForFwMw2: ", quý khách vui lòng gọi thêm trong lượt tiếp theo.",
      noteForFwMw3: "Bạn có biết",
      noteForFwMw4: "đã có trong",
      noteForFwMw5: "đặc sắc của",
      noteForFwMw6: "chưa?",
      noteForFwMw7: "Mời bạn khám phá thử combo đặc biệt này trước nhé.",
      textTitleBuffetExtra: "Thông báo",
      textContentBuffetExtra: "Order ngay",
      ticket: "vé",
      textContentBuffetExtra1:
        " để được gọi thỏa thích các món trong menu Extra bạn nhé!",
      textContentButtonLeft: "Tiếp tục chọn món",
      textContentButtonAddCart: "Vào giỏ hàng",
      textContentButtonLeft1: "Gọi NV tư vấn",
      textContentBuffetExtra2: "Mua thêm",
      textContentBuffetExtra3:
        " để được gọi thỏa thích các món trong menu Extra nhé!",
      tippingNow: "Hot tip",
      tipped: "Đã tip",
      tippingInfo: "Tiếp ngàn động lực cho nhân viên",
      textSorry: "XIN LỖI !",
      tippingContent: "Bất kỳ lựa chọn nào của bạn cũng là",
      tippingContent1: "động lực cho chúng tôi.",
      tippingContent2: "Tip cho nhân viên phục vụ bạn, thay lời cảm ơn!",
      tippingContent3: "Bạn đã tip",
      tippingPlaceHolder: "Hoặc nhập số tiền tip...",
      ratingTitle: "Hãy góp ý để chúng tôi phục vụ bạn",
      ratingTitle1: "với trải nghiệm trọn vẹn hơn!",
      ratingContent: "Bạn mong muốn cải thiện điều gì?",
      ratingContent2: "Gửi lời khen của bạn",
      submitConfirm: "Gửi đánh giá",
      notifyContentTipping: "Cảm ơn quý khách đã tip",
      notifyContentError: "Vui lòng chọn mức tip.",
      notifyContent: "Vui lòng chọn ",
      notifyContinue: " để tiếp tục",
      notifyContentMaxTextNote: "Không nhập quá 100 ký tự.",
      notifyContentSubmitRatingSuccess: "Đã gửi đánh giá thành công",
      notifyContentRating: "Chia sẻ trải nghiệm của bạn tại đây",
      notifyContentTimeoutCallStaff: "Cuộc gọi tạm thời bị mất kết nối.",
      notifyContentTimeoutCallStaff1:
        "Quý khách vui lòng gọi nhân viên gần nhất để được phục vụ.",
      close: "Đóng",
      notifyContentErrorComment: "Bạn chưa chọn đánh giá",
      textTitleChooseLanguage: "Chọn ngôn ngữ để tiếp tục",
      textVietnamese: "Tiếng việt",
      textEnglish: "English",
      textContinue: "Tiếp tục",
      orderMore1: "Xem lại menu",
      paymentNow: "Thanh toán ngay",
      payment: "Thanh toán",
      needSevice: "Yêu cầu ra món",
      searchPlaceHolder: "Tìm kiếm...",
      textSorryContent:
        "Không có kết quả tìm kiếm phù hợp. Bạn vui lòng thử lại với từ khoá khác nhé",
      in: "trong",
      noteTitle: "Ghi chú",
      listDishTitle: "Danh sách món trong set",
      titleQrCode: "Bạn đã dùng bữa xong và xác nhận muốn thanh toán?",
      back: "Quay lại",
      titleQrCodePaymentPopup: "Đã nhận được yêu cầu của bạn",
      titleQrCodePaymentPopup1: "để giúp bạn thanh toán nhé.",
      contentQrCodePaymentPopup:
        "Đợi một chút, nhân viên sẽ giúp bạn thanh toán nhé.",
      check: "Kiểm tra",
      cancelTippingDraftSuccess: "Huỷ tipping thành công",
      paymentInfo: "Thông tin đơn hàng",
      dishOrderedTitle: "Món đã gọi",
      productDetail: "Mô tả sản phẩm",
      loadMore: "Xem thêm",
      shorten: "Rút gọn",
      all: "Tất cả",
      paymentTitle: "Phương thức thanh toán",
      vatTitle: "Xuất hoá đơn VAT",
      vatSheetTitle: "Xuất hóa đơn VAT",
      vatSheetDesc1:
        "Vui lòng chọn “Xuất hóa đơn VAT” trước khi thanh toán nếu cần xuất hóa đơn theo thông tin riêng. Nếu không, hệ thống mặc định xuất hóa đơn khách lẻ và không thể điều chỉnh.",
      vatSheetDesc2:
        "Lưu ý: Tiền Tip không chịu VAT và không nằm trong hóa đơn VAT.",
      understood: "Đã hiểu",
      detail: "Chi tiết",
      change: "Thay đổi",
      totalPaymentTitle: "Tổng tiền cần thanh toán",
      titleVat: "Thêm thông tin xuất hoá đơn",
      vat1: "Có mã số thuế",
      vat2: "Không có mã số thuế",
      placeholderTaxCode: "Nhập mã số thuế*",
      companyNameHolder: "Tên đơn vị/cá nhân xuất hoá đơn *",
      addHolder: "Địa chỉ*",
      addHolder1: "Địa chỉ",
      placeholderPhoneNumber: "Số điện thoại*",
      placeholderEmail: "Email*",
      placeholderId: "Số CCCD",
      placeholderCustomerName: "Tên người mua hàng",
      errorVat:
        "Mã số thuế không đúng định dạng. Mã số thuế không đúng định dạng. Định dạng đúng là 10 ký tự số (0123456789) hoặc 14 ký tự bao gồm 13 ký tự số và ký tự " -
        " (0123456789-012).",
      errorNoInputVat: "Bạn chưa nhập mã số thuế",
      errorVatPhone:
        "Định dạng số điện thoại chỉ bao gồm ký tự số, không có khoảng trắng và bắt đầu từ số “0.",
      errorVatEmail: "Định dạng email là acb@domain.",
      inputInfo: "Nhập thông tin",
      contentErrorNoInfoVat:
        "Quý khách vui lòng kiểm tra lại mã số thuế [MST] hoặc nhập thủ công thông tin xuất hoá đơn. ",
      titleErrorNoInfoVat: "Mã số thuế không tra cứu được",
      errorNoInputEmailVat: "Đây là trường bắt buộc.",
      warningInfoCompanyName:
        "Nếu quý khách muốn lấy HĐ cho cá nhân, vui lòng nhập họ và tên tại ô này.",
      titleTax: "Mã số thuế",
      titleCompanyName: "Tên đơn vị/cá nhân:",
      titleAdd: "Địa chỉ:",
      titlePhone: "Số điện thoại:",
      titleEmail: "Email:",
      edit: "Chỉnh sửa",
      titleCustomerName: "Tên người mua hàng:",
      titleCCCD: "Số CCCD",
      unitCode: "Đơn vị quan hệ ngân sách",
      goldenSpoonsTitle: "Đăng nhập để không bỏ lỡ điểm thưởng",
      loginTitleNow: "Hơn 80% khách hàng tại {{brand}} đã tích điểm hôm nay.",
      placeholderPhone: "Nhập số điện thoại của bạn",
      textButtonLogin: "Đăng nhập tích điểm với Golden Gate",
      placeHolderPass: "Nhập mật khẩu của bạn",
      or: "Hoặc",
      loginWithGoldenGateApp: "Đăng nhập bằng App Golden Gate",
      loginButtonShort: "Đăng nhập",
      logout: "Đăng xuất",
      cannotOpenGoldenGateApp:
        "Không thể mở ứng dụng Golden Gate. Vui lòng thử lại hoặc đăng nhập bằng số điện thoại.",
      appLoginSyncError:
        "Không thể đồng bộ trạng thái đăng nhập Golden Gate. Vui lòng thử lại.",
      appLoginSessionExpiredTitle: "Phiên xác thực đã hết thời gian",
      appLoginSessionExpiredContent: "Vui lòng thử lại.",
      appLoginNoInternetTitle: "Không có kết nối Internet",
      appLoginNoInternetContent: "Vui lòng kiểm tra kết nối và thử lại.",
      textContinuePayment: "Tiếp tục thanh toán",
      titleErrorSignUp: "Phát hiện lỗi đăng ký",
      titleErrorSignUp1: "Tài khoản đang bị khoá",
      contentErrorSignUp2:
        "Số điện thoại đang gắn với nhiều tài khoản, vui lòng liên hệ hotline “19006622” để được hỗ trợ.",
      contentErrorSignUp3:
        "Tài khoản của quý khách đang bị khoá, vui lòng liên hệ hotline “19006622” để được hỗ trợ.",
      contentErrorSignUp:
        "Số điện thoại đang gắn với nhiều tài khoản, vui lòng liên hệ hotline",
      contentErrorSignUp1: "để được hỗ trợ",
      callNow: "Gọi ngay",
      phoneValidError: "Số điện thoại không đúng định dạng",
      policyValidError: "Bạn chưa chấp nhận với điều khoản sử dụng.",
      hello: "Xin chào,",
      loginContentWithPhone: "Bạn đang đăng nhập bằng SĐT ",
      forgotPass: "Quên mật khẩu",
      titleForgotPass: "Bạn quên mật khẩu?",
      contentForgotPass:
        "Vui lòng mở ứng dụng Golden Gate để khôi phục lại mật khẩu đăng nhập mới",
      textErrorPhone: "Số điện thoại phải có 10 chữ số",
      verifyOTPTitle: "Xác thực OTP",
      inputOTPTitle: "Nhập mã 4 số được gửi đến",
      titleResendOTP: "Gửi lại OTP sau",
      titleResendOTP1: "Gửi lại OTP",
      titleWrongOtp: "Đã nhập sai mã OTP 5 lần",
      contentWrongOtp: "Bạn vui lòng thử lại sau",
      contentWrongOtp1: "phút ngày",
      textReLogin: "Đăng nhập/Đăng kí sau",
      errorOtp: "Mã OTP sai hoặc hết hạn. Bạn còn",
      errorOtp1: "lần nhập.",
      errorPassword: "Mật khẩu đã bị nhập sai 5 lần",
      errorContentPassword:
        "Tài khoản của bạn đã bị khóa. Vui lòng thử lại sau 30 phút.",
      errorCorrectPassword: "Mật khẩu không đúng! Bạn còn",
      errorCorrectPassword1: "lần nhập.",
      titlePasswordTab: "Mật khẩu đăng nhập",
      contentPasswordTab:
        "Mật khẩu giúp tài khoản của bạn bảo mật và an toàn hơn.",
      titleCreatePassword: "Tạo mật khẩu",
      titleConfirmPassword: "Xác nhận mật khẩu",
      noteForPassword:
        "Bằng việc tiếp tục, bạn xác nhận đã đọc và đồng ý với Điều khoản sử dụng, Chính sách bảo mật và Chính sách thành viên.",
      noteForPassword2: "Điều khoản sử dụng.",
      errorPasswordCreate: "Mật khẩu cần ít nhất 6 số",
      errorPasswordConfirm: "Mật khẩu không trùng khớp",
      textConfirmCloseModalSignin:
        "Bạn có chắc chắn muốn thoát luồng đăng ký/đăng nhập?",
      textConfirmSignUpSuccess: "Đăng ký tài khoản thành công.",
      titleVoucher: "Ưu đãi",
      titleSearch: "Tìm kiếm",
      contentNoVoucher: "Chưa có ưu đãi dành riêng cho bạn",
      expiryDate: "Hạn đến",
      placeholderInputVoucher: "Nhập mã giảm giá ...",
      textCheckedVoucer: "Đã chọn",
      textvoucher: "ưu đãi",
      applyNow: "Áp dụng ngay",
      applyTitleNow: "Nội dung chương trình:",
      cancelApply: "Hủy áp dụng",
      addApplyVoucher: "Địa điểm áp dụng:",
      validateApply: "Điều kiện áp dụng",
      listDishApplyVoucher: "Danh  sách món được áp dụng ưu đãi",
      noSubmit: "Chưa gọi",
      submited: "Đã gọi",
      voucherError: "Thông tin voucher không hợp lệ",
      contentErrorVoucher:
        "Rất tiếc, ưu đãi này hiện không khả dụng với đơn hàng. Vui lòng xem thêm voucher khả dụng khác.",
      titleScanQrcode: "Quét mã QR",
      titlePartner: "Phương thức thanh toán",
      paymentInfoTitle: "Thông tin thanh toán",
      totalPayment: "Tổng tiền hàng",
      texttotalPayment: "Tổng tiền phải trả",
      textTotalTip: "Tiền tip thêm",
      reloadQRCode: "Tải lại QRCode",
      errorConfirmPayment: "Vui lòng đợi thêm một chút nhé",
      errorConfirmPayment1:
        "Đang có phiên thanh toán diễn ra. Bạn có muốn mở phiên thanh toán mới?",
      errorConfirmPayment2: "Đang có phiên thanh toán diễn ra.",
      contentErrorConfirmPayment: "Nhân viên đang hỗ trợ bạn thanh toán",
      contentAccountAddPoint: "Đơn hàng đã được tích điểm cho mã khách hàng",
      addPoint: "nên không thể sử dụng voucher trong ví Golden Gate.",
      checkedTgsAccount: "Đơn hàng đã được tích điểm cho mã khách hàng",
      checkedTgsAccount1: ".Bạn xác nhận tiếp tục thanh toán?",
      contentCheckUserTgs:
        "Quý khách vui lòng tạo phiên thanh toán mới: Giỏ hàng -> Món đã gọi -> Thanh toán ngay hoặc liên hệ nhân viên gần nhất để được hỗ trợ.",
      contentCheckUserTgs1:
        "Quý khách chắc chắn muốn tích điểm cho số điện thoại",
      // contentCheckUserTgs2: "hoặc liên hệ nhân viên gần nhất để được hỗ trợ.",
      paymentInfoTitle1: "Phiếu thanh toán",
      momoTitlePayment: "Thanh toán qua ví điện tử Momo",
      momoContentPayment:
        "Mở ứng dụng trên thiết bị của bạn để hoàn tất thanh toán tại nhà hàng",
      openMomoAppNow: "Mở ứng dụng Momo ngay",
      paymentByQrCode: "Thanh toán bằng QR code",
      paymentByQrCode1: "Thanh toán bằng QR code",
      saveQrCode: "Lưu QR code ",
      titleCheckPaymentStatus: "Kiểm tra trạng thái thanh toán",
      errorNoSelectPaymentPartner: "Bạn chưa chọn phương thức thanh toán.",
      serveyService: "Đánh giá dịch vụ",
      paymentSuccessTitle: "Thanh toán thành công",
      paymentSuccessTitleByCash:
        "Khách hàng vui lòng thanh toán với nhân viên phục vụ.",
      paymentSuccessContent:
        "Chia sẻ cho chúng tôi trải nghiệm của bạn bằng cách đánh giá bữa ăn này nhé!",
      titleByCash: "Cảm ơn quý khách, hẹn gặp lại.",
      titleContent: "Bạn có chắc chắn muốn quay lại màn hình thanh toán?",
      titleAppInApp: "Thanh toán qua App MoMo",
      verifyPayment: "Đang xác thực thanh toán",
      verifyPaymentContent:
        "Hệ thống đang tiến hành kiểm tra và xác thực thanh toán của bạn. Vui lòng đợi nhé!",
      verifyPaymentContent1:
        "Vui lòng không đóng ứng dụng khi bạn đang thực hiện thanh toán, trình duyệt sẽ tự động chuyển tiếp sau khi hoàn thành.",
      voucherNoValidTitle: "Voucher không hợp lệ",
      voucherNoValidContent:
        "Rất tiếc, ưu đãi này hiện không khả dụng với đơn hàng. Vui lòng xem thêm voucher khả dụng khác.",
      titleApplyVoucherError: "Áp dụng voucher không thành công",
      contentApplyVoucherError:
        "Vui lòng bỏ chọn các voucher bị lỗi để tiếp tục thanh toán hoặc xem thêm các voucher khả dụng khác.",
      removeSelectVoucher: "Bỏ chọn Voucher",
      contentNoApplyVoucher:
        "Bạn có chắc chắn muốn thanh toán mà không áp dụng voucher đó",
      voucherErrorCheck:
        "Bạn có chắc chắn muốn thanh toán mà không áp dụng voucher đó",
      unSelectVoucher: "Bỏ chọn Voucher",
      errorTitleWhenCheckTGS: "Có lỗi xảy ra trong quá trình tích điểm",
      paymentByGbizTitle: "Thanh toán bằng tài khoản G-Business",
      accountLimit: "Hạn mức tài khoản:",
      amountToPay: "Số tiền cần thanh toán:",
      totalAmount: "Tổng tiền phải trả",
      titleErrorWhenPayment: "Giao dịch chưa được thanh toán",
      titleErrorWhenPayment1: "Giao dịch đang được cập nhật thanh toán",
      errorTitle: "Có lỗi xảy ra",
      noTakeVat: "Quý khách đã xác nhận không lấy hóa đơn.",
      noTakeTaxTitle: "Quý khách vui lòng liên hệ ",
      rm: "QUẢN LÝ NHÀ HÀNG ",
      support: " để được hỗ trợ.",
      contentNotifyLockOrder:
        "Bạn đã xác nhận kiểm đồ, liên hệ nhân viên để gọi thêm món.",
      errorNoApplyDish: "Bạn chưa gọi món áp dụng voucher.",
      errorNoApplyDish1: "Bạn chưa chọn món được ưu đãi.",
      contentNoApplyDish:
        "Để sử dụng ưu đãi này vui lòng chọn món được áp dụng trong danh sách chi tiết voucher.",
      contentErrorTimeOut:
        "Rất xin lỗi, quý khách vui lòng thử lại sau ít phút. Hoặc gọi trực tiếp nhân viên gần nhất.",
      termAndCondition: "Điều khoản sử dụng",
      prepayPaymentDone: "Bạn đã hoàn thành thanh toán ",
      scanByCam: "Scan bằng camera",
      chooseImage: "Chọn từ thư viện ảnh",
      submitted: "Đã gọi",
      titleLoadImageQrCode: "Không tìm thấy QRCode trong ảnh",
      contentLoadImageQrCode:
        "Rất tiếc, hệ thống không tìm thấy mã Qrcode của ảnh voucher mà bạn tải lên. Vui lòng lựa chọn ảnh khác và thử lại.",
      titleModalRemoveVoucher: "Đơn hàng đã được tích điểm",
      textRemoveVoucherButton: "Bỏ voucher trong ví",
      contentRemoveVoucher: "Đơn hàng đã được tích điểm cho mã khách hàng",
      contentRemoveVoucher1:
        "Vui lòng bỏ chọn các voucher trong ví GS trong phần chi tiết voucher, hoặc bấm nút “Bỏ voucher trong ví” để tiếp tục thanh toán.",
      contentRemoveVoucher2: "“Bỏ voucher trong ví”",
      contentTypeOne:
        "Vui lòng đăng nhập tài khoản Golden Gate và chọn voucher trong ví để sử dụng.",
      titleTypeOne: "Ưu đãi không hơp lệ",
      contentTypeGiftOne:
        "Voucher chưa được hỗ trợ sử dụng trên QrCode Order. Vui lòng quét QrCode kiểm đồ bằng app GS để sử dụng voucher này.",
      choosePaymentMethodVinId: "Chọn cách thức thanh toán",
      usePointVinId: "Sử dụng U-Point",
      walletVinId: "Ví OneU",
      titleVinId: "Nhập số tiền muốn thanh toán bằng điểm OneU",
      placeholderVinId: "Nhập số tiền tại đây",
      errorVinId:
        "Vui lòng thanh toán toàn bộ bill cùng tiền tip hoặc nhập tối đa",
      errorVinId1:
        "Số tiền muốn thanh toán bằng điểm U-Point không được lớn hơn tổng tiền cần thanh toán của đơn hàng.",
      payByVinIdTitle: "Thanh toán bằng điểm OneU",
      chooseCategory: "Chọn menu",
      ordertopay: "Gọi món tính tiền",
      chooseMenu: "Chọn menu",
      justOne: "Chỉ từ",
      openTable: "Choose Menu",
      chooseAgain: "Chọn lại",
      chooseCategoryConfirm: "Bạn có chắc chắn muốn chọn ",
      justOne1: "với giá chỉ từ",
      justOne2: "với giá",
      justOne3: "/Món",
      chooseMenuOverTime: "Phiên chọn menu đã hết hiệu lực",
      chooseMenuOverTimeContent:
        "Vui lòng liên hệ nhân viên gần nhất để chọn menu hoặc quét lại QRCode Order.",
      groupCombo: "Nhóm món cố định",
      titleHideCategory: "Menu được cấu hình ẩn order trên Qrcode",
      person: "/Người",
      contentHideCategory:
        "Chúng tôi rất tiếc về trải nghiệm không trọn vẹn của Quý khách tại nhà hàng. Vui lòng liên hệ nhân viên gần nhất để hỗ trợ Quý khách.",
      oneMountTitlePayment: "Thanh toán qua ví điện tử OneU",
      openVinIdAppNow: "Mở ứng dụng OneU ngay",
      titleAppInAppVinId: "Thanh toán qua App OneU",
      titleBackPayment: "Quay lại màn hình thanh toán",
      titleAppInApp1: "Thanh toán qua App",
      errorPaymentOnemount:
        "Hệ thống sẽ tự động chuyển màn hình khi thanh toán thành công, hoặc có thể bấm nút [Kiểm tra trạng thái thanh toán] để kiểm tra trạng thái giao dịch.",
      titleVatNotify: "  Bạn chắc chắn không lấy hóa đơn VAT?",
      textInfo: "Hãy chia sẻ góp ý của bạn để được hỗ trợ ngay!",
      sendNow: "Gửi ngay",
      serviceFeedback: "Phản ánh dịch vụ",
      serviceFeedbackContent: "Mọi ý kiến của bạn đều quan trọng.",
      serviceFeedbackContent1:
        "Hãy để chúng tôi lắng nghe và hành động vì bạn.",
      callManager: "Gọi quản lý ngay",
      noteFeedback: "Góp ý của bạn",
      feedback: "Góp ý",
      notifyContentFeedback: "Chia sẻ góp ý của bạn tại đây",
      totalPaymentDiscount: "Tiền hàng được áp dụng khuyến mãi",
      phomeNumberFeedback: "Số điện thoại của bạn",
      tipTitle: "Tip cho nhân viên phục vụ bạn",
      tipTitle1: "Thay lời cảm ơn",
      hintTextTip: "Hoặc nhập số tiền tip",
      feedbackSuccess: "Gửi góp ý thành công",
      choose1: "Chọn",
      of: "trong",
      chooseSize: "Chọn size",
      notifyContentChooseComponent: "Bạn chưa chọn món trong combo",
      textTitleNoInternet: "Không có kết nối internet",
      apiNoResponse: "API không phản hồi",
      textReload: "Tải lại",
      textContentNoInternet:
        "Vui lòng kiểm tra kết nối mạng của bạn và\nthử lại.",
      noGPos:
        "Không lấy được phiên bản G-POS. Vui lòng tải lại trang và thử lại!",
      textNoChooseHotpotWater: "Bạn chưa chọn nước lẩu",
      hotpot2Compartment: "Lẩu 2 ngăn",
      hotpot4Compartment: "Lẩu 4 ngăn",
      toastMaxHotpot: "Bạn được chọn tối đa {{max}} ngăn nước lẩu",
      chooseHotpotFree:
        "Bạn được chọn {{free}} ngăn nước lẩu miễn phí, các ngăn tiếp theo sẽ được tính phí.",
      notifyDishNoExtraHotpot: "Rất xin lỗi quý khách",
      notifyDishNoExtraHotpot2:
        "chưa được cấu hình cho ngăn lẩu tính phí. Quý khách vui lòng gọi nhân viên gần nhất để được hỗ trợ gọi món.",
      chooseToAddHotpotFree:
        "Bạn còn chọn thêm được {{free}} ngăn nước lẩu miễn phí.",
      confirmSubmitHotpotTitle: "Bạn có chắc chắn muốn chọn",
      hotpotBroth: "Nước lẩu",
      selectMore: "Chọn thêm",
      useBoilingWater: "Dùng nước sôi",
      selectAnotherType: "Chọn tiếp loại khác",
      notConfigHotpotCharging: "Món chưa được cấu hình cho lẩu tính phí",
      ChooseMyHotpot: "Chọn nước lẩu của bạn",
      notifyHopot2: "Bạn đã chọn lẩu 4 ngăn, không thể chọn tiếp lẩu 2 ngăn.",
      notifyHopot4: "Bạn đã chọn lẩu 2 ngăn, không thể chọn tiếp lẩu 4 ngăn.",
      notifyHotpot3: "Bạn không thể chọn lại lẩu 4 ngăn.",
      notifyHotpot7: "Bạn không thể chọn lại lẩu 2 ngăn.",
      notifyHotpot5: "Bạn có chắc chắn muốn chuyển sang lẩu 4 ngăn không?",
      notifyHotpot6: "Bạn có chắc chắn muốn chuyển sang lẩu 2 ngăn không?",
      messageFwIsushi:
        "Bạn đã chọn đủ số món cho lượt này! Cùng thưởng thức trước khi tiếp tục nhé.",
      times: "Lượt",
      hour: "Giờ",
      staffAssistCardPayment: "Nhân viên sẽ hỗ trợ thanh toán bằng thẻ",
      staffAssistCardPaymentNoti: "Vui lòng đưa thẻ cho nhân viên và giữ nguyên màn hình này. Hệ thống sẽ tự động cập nhật sau khi thanh toán thành công",
      retry: "Thử lại",
      retryOrAnotherPayment:
        "Vui lòng thử lại hoặc chọn phương thức thanh toán khác",
      hottip: "Tip ngay",
      contentHottip:
        "Hãy tiếp thêm động lực tới những nhân\nviên phục vụ đã góp phần mang đến cho\nbạn trải nghiệm trọn vẹn ngày hôm nay.\nChúc bạn có một bữa ăn thật ngon miệng!",
      errorVatUnitCode: "Bạn đã nhập quá 7 kí tự",
      contentLockTGS:
        "Rất tiếc, bạn không tích điểm được vì đã đạt tối đa số lần tích điểm trong khung giờ này",
      orderProcessing: "Đang xử lý order",
      contentErrorSubmitOrder:
        "Order trước của bạn đang được xử lý. Vui lòng đợi trong giây lát trước khi gọi món tiếp theo.",
      tippingContent12: "Ghi nhận cho nhân viên",
      pointSurvey: "Điểm đánh giá: ",
      surveyTitle: "Hãy đánh giá trải nghiệm của bạn để ghi nhận cho",
      surveyTitle2: "nhé",
      surveyTitle3:
        "Hãy đánh giá trải nghiệm của bạn để ghi nhận cho nhà hàng nhé",
      contentTipping:
        "Nếu bạn muốn gửi lời cảm ơn đến đội ngũ phục vụ hôm nay, mọi khoản tip sẽ được chuyển trực tiếp đến nhân viên",
      tippingForStaff: "Tip cho nhân viên",
      tippingMost: "TIP nhiều nhất",
      callStaff1: "Gọi nhân viên",
      contentTilteCallStaff:
        "Để bắt đầu gọi món, Quý khách vui lòng gọi nhân viên hỗ trợ xác nhận mở bàn.",
      orderDish: "Gọi món",
      timeSteaming: "Thời gian hấp:",
      minute: "'",
      relateTitleDish: "Gợi ý món ăn kèm",
      contentTilteCallStaff1:
        "Để bắt đầu gọi món, Quý khách vui lòng gọi nhân viên hỗ trợ xác nhận mở bàn.",
      noteFromTotalPayment:
        "Tổng tiền chưa bao gồm VAT và các phí dịch vụ khác",
      noteFromTotalPayment1:
        "Tạm tính chưa bao gồm VAT và các phí dịch vụ khác",
      textButtonVat: "Nhập thông tin xuất hoá đơn VAT",
      textNoteVat:
        "Hoặc vui lòng nhấp vào nút 'Nhập thông tin xuất hóa đơn VAT' bên dưới.",
      textTks: "đã được thanh toán, cảm ơn quý khách",
      textTks1: "Hãy nhớ quay lại ủng hộ",
      textTks2: "vào những lần sau nhé",
      textTitelPersonal: "Đồng ý sử dụng dữ liệu cá nhân.",
      textContentPersonal:
        "Khi sử dụng ứng dụng gọi món thông qua QRCode tại Nhà hàng, Quý khách đồng ý cho chúng tôi thu thập và xử lý một số dữ liệu, bao gồm: thông tin định danh (nếu cung cấp), lịch sử gọi món, thời gian sử dụng dịch vụ và các tương tác trên ứng dụng.",
      textContentPersonal1:
        "Dữ liệu này được chuyển đến hệ thống quản lý dữ liệu khách hàng (CDP) nhằm:",
      textContentPersonal2:
        "Cá nhân hóa ưu đãi và chương trình khuyến mãi phù hợp với sở thích của Quý khách.",
      textContentPersonal3:
        "Gửi lời mời tham gia khảo sát về trải nghiệm tại Nhà hàng hoặc về món ăn đã sử dụng.",
      textContentPersonal11:
        "Phân tích và cải thiện chất lượng sản phẩm, dịch vụ.",
      textContentPersonal4: "Chúng tôi cam kết:",
      textContentPersonal5: "Chỉ sử dụng dữ liệu cho các mục đích nêu trên.",
      textContentPersonal6: "Không chia sẻ dữ liệu cho bên thứ ba trái phép.",
      textConfirmPersonal: "Tôi đồng ý",
      textCancelPersonal: "Từ chối",
      textLinkPolicyPersonal: "Xem thêm chính sách bảo mật thông tin.",
      voucherNotSelected: "Bạn chưa chọn voucher nào",
      priceTitel: "Đơn giá",
      intoMoney: "Thành tiền",
      itemDish: "Giục ra món thành công",
      confirmMenuChange: "Bạn có chắc chắn thay đổi từ {oldMenu} sang {newMenu}?",
      confirmDeleteAllCart: "Bạn có chắc chắn xóa tất cả món ăn trong giỏ hàng?",
      confirmOrder: "Xác nhận gọi món",
      complimentary: "MÓN MỜI",
      addItemsNow: "Thêm món ngay",
      notOrderedItemsYet: "Bạn chưa gọi món nào.",
      items: "món",
      item: "món",
      deleteAllItems: "Xoá tất cả món",
      backOrder: "Quay lại gọi món",
      continuePayment: "Tiếp tục thanh toán",
      add: "Thêm",
      rateStarText: "Hãy tặng sao cho {{name}} nhé!",
      rateStarTextBefore: "Hãy tặng sao cho",
      rateStarTextAfter: "nhé!",
      tipSentTo: "Tiền Tip sẽ được gửi đến",
      submitWithTip: "Gửi đánh giá kèm TIP",
      topTipper: "TIP nhiều nhất",
      orEnterTip: "Hoặc nhập số tiền tip ...",
      tipSplitMessage:
        "Gửi Tip, trao lời cảm ơn: 70% Tip dành tặng <b>{{name}}</b>, 30% gửi tới đội ngũ phục vụ.\nTiền Tip không chịu VAT và không nằm trong hóa đơn VAT",
      noTipOption: "Không TIP",
      youTipped: "Bạn đã Tip",
      rateTipConfirmButton: "Xác nhận",
    },
  },
};
i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem("currentLanguage") || "vie",
  fallbackLng: "vie",
  keySeparator: false,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
